import React, { useEffect } from "react";
import * as Mui from "@mui/material";
import { themes } from "services/constants";
export const ErrorHandle = ({ attendance, setErrorUpdate, updateError }) => {
  const dateFormat = attendance.date;

  useEffect(() => {
    if (updateError) {
      setErrorUpdate(false);
    }
  }, [setErrorUpdate, updateError]);

  const ErrorHandle = ({ errorMessage }) => (
    <Mui.Typography
      variant="body2"
      color="error"
      sx={{
        fontSize: 17,
        paddingLeft: 3,
        paddingTop: 0.5,
        fontWeight: "bold",
      }}
    >
      {errorMessage}
    </Mui.Typography>
  );

  const getErrorMessage = () => {
    if (attendance.entryCountMissMatch) {
      return `${dateFormat} - The number of IN and OUT punches are not balanced. Please verify the missing entry.`;
    }
    if (attendance.properCheckinCheckOutTimeError) {
      return `${dateFormat} - Your time entry has an inconsistency between the IN and OUT times. Kindly verify.`;
    }
    if (attendance.duplicateEntries) {
      return `${dateFormat} - Duplicate entries detected. Please ensure all entries are unique.`;
    }
    if (attendance.shiftEndTimeBasedError) {
      return `${dateFormat} - Since the shift has already ended, irregular entries cannot be recorded.`;
    }
    return null;
  };

  const errorMessage = getErrorMessage();

  return (
    <React.Fragment>
      <Mui.Grid
        container
        sx={{
          backgroundColor: themes?.miliedRedColor,
        }}
      >
        {errorMessage && <ErrorHandle errorMessage={errorMessage} />}
      </Mui.Grid>
    </React.Fragment>
  );
};
